import "./Intro.css";
import PublicProgramInfoContent from "./PublicProgramInfoContent";

export default function Intro({ programNumber, programInfoYear }) {
  return (
    <div className="intro-text">
      <PublicProgramInfoContent
        programNumber={programNumber}
        year={programInfoYear}
      />
    </div>
  );
}
